import type { MRT_ColumnDef } from '@talentmesh/table';
import Header from '../Components/Header';
import NameAndEmail from '../Components/NameAndEmail';
import Role from '../Components/Role';
import Status from '../Components/Status';
import TeamMemberActionsCell from '../Components/TeamMemberActionsCell';
import { TeamMember } from '@/Models/TeamMember';
import UIStrings from '@/Utils/UIStrings';

export default function createTeamMembersTableColumns(): MRT_ColumnDef<TeamMember>[] {
    return [
        {
            id: 'nameAndEmail',
            accessorFn: (row) => `${row.firstName} ${row.lastName} ${row.email}`,
            header: UIStrings.NameAndEmail,
            Header: () => <Header header={UIStrings.NameAndEmail} />,
            size: 400,
            enableSorting: false,
            Cell: NameAndEmail,
        },
        {
            id: 'role',
            accessorKey: 'role',
            header: UIStrings.Role,
            Header: () => <Header header={UIStrings.Role} />,
            size: 200,
            enableSorting: false,
            Cell: Role,
        },
        {
            id: 'status',
            accessorKey: 'status',
            header: UIStrings.Status,
            Header: () => <Header header={UIStrings.Status} />,
            size: 200,
            enableSorting: false,
            Cell: Status,
        },
        {
            id: 'actions',
            columnDefType: 'display',
            header: ' ',
            Header: () => null,
            size: 300,
            enableSorting: false,
            mantineTableBodyCellProps: { className: 'text-center' },
            Cell: TeamMemberActionsCell,
        },
    ];
}
